// API Base URL
// export const API_BASE_URL = 'http://localhost:5000/api/support';
export const API_BASE_URL = '/api/support';

// Roles
export const ROLES = {
  AGENT: 'agent',
  TEAM_LEAD: 'team_lead',
  MANAGER: 'manager'
};

// Ticket Status
export const TICKET_STATUS = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed',
  PENDING: 'Pending'
};

// Ticket Priority
export const TICKET_PRIORITY = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  URGENT: 'Urgent'
};

// Agent Status
export const AGENT_STATUS = {
  ONLINE: 'Online',
  AWAY: 'Away',
  OFFLINE: 'Offline'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER_DATA: 'user_data'
};
